// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation UpdateInvoiceMutation($input: UpdateInvoiceInput!) {
    updateInvoice(input: $input) {
      invoiceEdge {
        node {
          id
          invoiceNumber
          status
          currency
          subtotal
          discountPercent
          discountAmount
          taxRate
          taxAmount
          totalAmount
          amountPaid
          amountDue
          partialPercent
          milestoneLabel
          issueDate
          dueDate
          paidDate
          notes
          terms
          order {
            id
            orderNumber
          }
          customer {
            id
            name
          }
          updatedAt
          createdAt
        }
      }
    }
  }
`;

export default {
  commit: (options: Object) => {
    return createRelayMutation(mutation, {
      ...options,
    });
  },
};
